"function"!=typeof Promise&&require("promise-polyfill/dist/polyfill");


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@3.0.14@dingtalk-jsapi/lib/polyfills/es6Promise.js
// module id = 1141
// module chunks = 106